'use strict'

var caseSensitiveTransform = require('./case-sensitive-transform')

module.exports = caseInsensitiveTransform

function caseInsensitiveTransform(attributes, property) {
  return caseSensitiveTransform(attributes, property.toLowerCase())
}



//////////////////
// WEBPACK FOOTER
// ./~/rehype-react/~/property-information/lib/util/case-insensitive-transform.js
// module id = 103
// module chunks = 33019919093843 87034247430840 144482056661899